<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appAdminSidebar></appAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <h4>General</h4>
            <div class="row px-2">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 my-2 p-3 border">
                <h6>Pulse API Product Info</h6>
                <div class="m-2">
                  <b class="my-2">SKU Or Product Id:</b>
                  <b-form-input class="my-2"></b-form-input>
                  <b-button class="buttonStyle mt-2" variant="primary">Submit</b-button>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 my-2 p-3 border">
                <h6>Fix transaction dollar value</h6>
                <div class="m-2">
                  <b class="my-2">Item order number:</b>
                  <b-form-input class="my-2"></b-form-input>
                  <b-button class="buttonStyle mt-2" variant="primary">Submit</b-button>
                </div>
              </div>
            </div>
            <div class="row px-2">
              <div
                class="
                  col-xs-12 col-sm-6 col-md-6 col-lg-6
                  my-2
                  p-3
                  border
                "
              >
                <h6>Lookup product children by parent</h6>
                <div class="m-2">
                  <b class="my-2">Product Id:</b>
                  <b-form-input class="my-2"></b-form-input>
                  <b-button class="buttonStyle mt-2" variant="primary">Submit</b-button>
                </div>
              </div>
            </div>
            <hr />
            <div class="row px-2">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 my-2 p-3 border">
                <h6>Query sears product feed</h6>
                <div class="m-2">
                  <b class="my-2">Product child Id:</b>
                  <b-form-input class="my-2"></b-form-input>
                  <b class="my-2">Sears item Id:</b>
                  <b-form-input class="my-2"></b-form-input>
                  <b-button class="buttonStyle mt-2" variant="primary">Submit</b-button>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 my-2 p-3 border">
                <h6>Query sears availability feed</h6>
                <div class="m-2">
                  <b class="my-2">Product child Id:</b>
                  <b-form-input class="my-2"></b-form-input>
                  <b class="my-2">Sears item Id:</b>
                  <b-form-input class="my-2"></b-form-input>
                  <b-button class="buttonStyle mt-2" variant="primary">Submit</b-button>
                </div>
              </div>
            </div>
            <div class="row px-2">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 my-2 p-3 border">
                <h6>Query sears order</h6>
                <div class="m-2">
                  <b class="my-2">Sears order Id:</b>
                  <b-form-input class="my-2"></b-form-input>
                  <b-button class="buttonStyle mt-2" variant="primary">Submit</b-button>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 my-2 p-3 border">
                <h6>Query sears pricing feed</h6>
                <div class="m-2">
                  <b class="my-2">Product child Id:</b>
                  <b-form-input class="my-2"></b-form-input>
                  <b class="my-2">Sears item Id:</b>
                  <b-form-input class="my-2"></b-form-input>
                  <b-button class="buttonStyle mt-2" variant="primary">Submit</b-button>
                </div>
              </div>
            </div>
            <hr />

            <div class="row px-2">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 my-2 p-3 border">
                <h6>Refresh client product search index</h6>
                <div class="m-2">
                  <b class="my-2">Client Id: (0 = All Clients)</b>
                  <b-form-input class="my-2"></b-form-input>
                  <b-button class="buttonStyle mt-2" variant="primary">Submit</b-button>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 my-2 p-3 border">
                <h6>Refresh cached client category trees</h6>
                <b-button class="buttonStyle mt-2" variant="primary">Submit</b-button>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import divvyAdminSidebar from '@/views/divvyadmin/divvyAdminSidebar.vue';
export default {
  name: 'generalComponent',
  components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar,
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch('divvyAdminSidebar/setActive', {
        activeMenuItem: this.activeMenuItem ? this.activeMenuItem : 'general',
        activeMenu: this.activeMenu ? this.activeMenu : 'utilities',
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },

  created() {
    this.setActiveMenuItem();
    this.scrollToTop();
  },

  computed: {},
};
</script>
<style lang="scss" scoped>
html,
body {
  height: 100%;
}

.buttonStyle {
  border-radius: 1.5rem;
  // padding: 10px 20px;
}
</style>
